import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsProductsAdvancedRoadmapsHierarchyRoute: InvariantJiraRoute = {
	name: 'global-settings-products-advanced-roadmaps-hierarchy',
	path: '/secure/PortfolioHierarchy.jspa',
};
